import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

function SearchOverlay({ open, onClose }) {
    const inputRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (open) {
            const timer = setTimeout(() => {
                inputRef.current?.focus();
            }, 50);
            return () => clearTimeout(timer);
        }
        return undefined;
    }, [open]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const query = inputRef.current?.value?.trim();
        if (!query) {
            return;
        }
        onClose();
        navigate(`/search?q=${encodeURIComponent(query)}`);
    };

    return (
        <div
            className={`search-overlay${open ? ' open' : ''}`}
            id="search-overlay"
            role="search"
            aria-label="Search"
            onClick={(event) => {
                if (event.target === event.currentTarget) {
                    onClose();
                }
            }}
        >
            <div className="search-inner">
                <form className="search-form" role="search" onSubmit={handleSubmit}>
                    <label>
                        <span className="screen-reader-text">Search for:</span>
                        <input
                            ref={inputRef}
                            type="search"
                            className="search-field"
                            placeholder="Search …"
                            name="s"
                            defaultValue=""
                        />
                    </label>
                    <input type="submit" className="search-submit" value="Search" />
                </form>
                <p className="small-meta" style={{ marginTop: '1rem' }}>Press ESC to close</p>
            </div>
        </div>
    );
}

export default SearchOverlay;
